// Discount maths matching SAP: the discount amount is rounded to 2dp first, then subtracted.
// Keep in sync with server/utils/orderMath.js.

// toPrecision(12) strips float noise so 2.535 rounds half-up to 2.54.
export function round2(n) {
  return Math.round(parseFloat((n * 100).toPrecision(12))) / 100;
}

export function lineAmounts(quantity, unitPrice, discountPct) {
  const gross = round2((parseFloat(quantity) || 0) * (parseFloat(unitPrice) || 0));
  const discount = round2(gross * (parseFloat(discountPct) || 0) / 100);
  return { gross, discount, net: round2(gross - discount) };
}

// Totals over lines that are already filtered to top-level (non pack-child) lines.
// The discount is rounded once per discount rate on the summed gross (not per line), so a
// uniform order discount equals round2(orderGross * pct / 100).
export function orderTotals(lines) {
  const grossByPct = new Map();
  let gross = 0;
  for (const l of lines) {
    const g = lineAmounts(l.Quantity, l.UnitPrice, 0).gross;
    const pct = parseFloat(l.DiscountPct) || 0;
    grossByPct.set(pct, (grossByPct.get(pct) || 0) + g);
    gross += g;
  }
  let discount = 0;
  for (const [pct, g] of grossByPct) discount += round2(round2(g) * pct / 100);
  gross = round2(gross);
  discount = round2(discount);
  return { gross, discount, net: round2(gross - discount) };
}
